class SearchForm extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input[type="search"]');
        this.resetButton = this.querySelector('button[type="reset"]');
        this.searchModal = this.closest('details'); // Closest <details> element containing the modal

        // Find the close button globally (outside this element)
        this.closeButton = document.querySelector('.search-modal__close-button');

        if (this.input) {
            this.input.form.addEventListener('reset', this.onFormReset.bind(this));
            this.input.addEventListener(
                'input',
                debounce((event) => {
                    this.onChange(event);
                }, 300).bind(this)
            );
        }

        if (this.closeButton) {
            this.closeButton.addEventListener('click', this.closeModal.bind(this));
        }
    }

    toggleResetButton() {
        const resetIsHidden = this.resetButton.classList.contains('hidden');
        if (this.input.value.length > 0 && resetIsHidden) {
            this.resetButton.classList.remove('hidden');
        } else if (this.input.value.length === 0 && !resetIsHidden) {
            this.resetButton.classList.add('hidden');
        }
    }

    onChange() {
        this.toggleResetButton();
    }

    shouldResetForm() {
        return !document.querySelector('[aria-selected="true"] a');
    }

    onFormReset(event) {
        // Prevent default so the form reset doesn't set the value from the URL on page load
        event.preventDefault();
        // Don't reset if the user has selected an element on the predictive search dropdown
        if (this.shouldResetForm()) {
            this.input.value = '';
            this.input.focus();
            this.toggleResetButton();
        }
    }

    closeModal() {
        // Close the search modal by removing the `open` attribute
        if (this.searchModal) {
            this.searchModal.removeAttribute('open');
            console.log("Search modal closed.");
        } else {
            console.warn("No modal found to close.");
        }
    }
}

// Register the custom element
customElements.define('search-form', SearchForm);

// Debounce utility function
function debounce(func, delay) {
    let timer;
    return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func(...args);
        }, delay);
    };
}